import Flex, { IFlex } from 'components/Flex';
import Title from 'components/PageTitle/Small';
import useTheme from 'hooks/useTheme';
import React, { FunctionComponent, ReactElement, ReactNode } from 'react';
import styled, { StyledComponent } from 'styled-components/macro';

export interface ITransparentBasic {
  className?: string;
  children?: ReactNode;
  title?: ReactElement | string;
  rightComponent?: ReactNode;
  bottomComponent?: ReactNode | string;
  header?: StyledComponent<FunctionComponent<IFlex>, Record<string, never>>;
}

const TransparentBasic: FunctionComponent<ITransparentBasic> = ({
  className,
  children,
  title,
  rightComponent,
  bottomComponent,
  header: BasicHeader = Header,
}) => {
  const theme = useTheme();

  return (
    <div className={className}>
      <BasicHeader direction="column">
        <Flex justifyContent="space-between" alignItems="center">
          {typeof title === 'string' ? (
            <Title color={theme.colors.snow} fontSize="22px">
              {title}
            </Title>
          ) : (
            title
          )}
          {rightComponent}
        </Flex>
        <Flex>
          {typeof bottomComponent === 'string' ? (
            <SubTitle color={theme.colors.snow} fontSize="18px">
              {bottomComponent}
            </SubTitle>
          ) : (
            bottomComponent
          )}
        </Flex>
      </BasicHeader>
      {children}
    </div>
  );
};

export default TransparentBasic;

export const Header = styled(Flex)`
  flex-direction: column;
  min-height: 56px;
  box-sizing: border-box;
  padding: 17px 32px 10px 32px;
  background-color: ${(props) => props.theme.colors.accentNormal};
  color: ${(props) => props.theme.colors.show};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  ${(props) => props.theme.media.xs`
    padding: 17px 20px 13px 20px;
  `}
`;

export const SubTitle = styled(Title)`
  font-family: Roboto;
  line-height: 18px;
`;

export const TabsWrapperComponent = styled.ul`
  flex: 1;
  white-space: nowrap;
  padding: 3px 10px 0 10px;
  border-bottom: 2px solid ${(props) => props.theme.colors.accentNormal};
  box-sizing: border-box;
  list-style: none;
  display: block;
  background: ${(props) => props.theme.colors.accentNormal};
  margin: 0;
`;

export const TabComponent = styled.li<{ isActive: boolean }>`
  display: inline-block;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: ${(props) => props.theme.colors.snow};
  text-decoration: none;
  box-sizing: border-box;
  cursor: pointer;
  border: none;
  border-radius: 4px 4px 0 0;
  padding: 13px 25px 13px 25px;
  outline: none;
  margin-bottom: -2px;
  transition: 0.3s color, border-bottom-color;
  &:hover {
    color: ${(props) => props.theme.colors.snow};
    background-color: ${(props) => props.theme.colors.accentHover};
  }
  ${({ isActive, theme }) =>
    isActive &&
    ` color: ${theme.colors.accentNormal};
      background-color: ${theme.colors.snow};
      cursor: default;
      &:hover {
        color: ${theme.colors.accentNormal};
        background-color: ${theme.colors.snow};
      }
    `}
`;
